var UIP_BASE_API_CONFIG = {
    auth: {
        clientId: '',
    },
};
export var getUipConfig = function () {
    return UIP_BASE_API_CONFIG;
};
export var setUipConfig = function (config) {
    Object.assign(UIP_BASE_API_CONFIG, config);
};
/**
 * Build separate B2C Policies for sign-in and sign-up based on authorization settings
 * @param settings Authorization settings
 */
export var buildB2cPolicies = function (settings) {
    var uipAuthorityDomain = settings.uipAuthorityDomain, uipSignUpSignInPolicy = settings.uipSignUpSignInPolicy, uipSignUpPolicy = settings.uipSignUpPolicy, uipTenantId = settings.uipTenantId;
    var signInPolicyName = uipSignUpSignInPolicy ? uipSignUpSignInPolicy : "B2C_1A_JABRAHLE_SignUpOrSignin" /* SignUpOrSignin */;
    var signUpPolicyName = uipSignUpPolicy ? uipSignUpPolicy : "B2C_1A_JABRAHLE_SignUp" /* SignUp */;
    return {
        authorities: {
            signIn: {
                authority: "https://" + uipAuthorityDomain + "/" + uipTenantId + "/" + uipSignUpSignInPolicy,
            },
            signUp: {
                authority: "https://" + uipAuthorityDomain + "/" + uipTenantId + "/" + uipSignUpPolicy,
            },
        },
        names: {
            signIn: signInPolicyName,
            signUp: signUpPolicyName,
        },
    };
};
